module.exports = __webpack_public_path__ + "img/img10.9d76feb0.svg";